import { Accordion, Box, Button, Card, Grid, InputSelect, InputText, Typo } from "#/atoms";
import { FC, memo } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { FreelanceOfferCardProps } from "./FreelanceOffer.interface";
import { HeadingIcon } from "#/molecules";
import { StyledSmallButtons } from "../OrderStatus/OrderStatus.styled";

const FreelanceOfferCard: FC<FreelanceOfferCardProps> = ({
  accordionState = 'open',
  allowFreelance,
  onChangeRole,
  orderOfferPrice,
  preferredWorker,
}) => {
  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="wallet" title="Freelance Offer" />}
        headerMargin={`${DESKTOP_SPACING.XXXL}px`}
        showArrow
        state={accordionState}
      >
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin={`${DESKTOP_SPACING.XXL}px 0 0`}>
          
           <Box margin="0 20px">
 
              <InputSelect
                type="checkbox"
                checked={allowFreelance.checked}
                label="Allow Freelance Offers"
                name="allowFreelance"
                value="allowFreelance"
                onChangeValue={allowFreelance.onChange}
              />         
              <InputText
                type="number"
                label="Order Offer Price"
                value={orderOfferPrice.value}
                onChange={orderOfferPrice.onChange}
              />
          </Box>
          <Box margin="0 20px">
            <Typo margin="0px 0px 20px">Preferred Worker: {preferredWorker && <strong>{preferredWorker.name}</strong>}</Typo>
            
            <StyledSmallButtons>
              <Button actionType='outline' buttonSize="md" onClick={onChangeRole}>Select Worker</Button>
            </StyledSmallButtons>
          </Box>
        </Grid>
      </Accordion>
    </Card>
  );
};

export default memo(FreelanceOfferCard);